var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "1rem", "padding-bottom": "1rem" } },
    [
      _c("topbar", { attrs: { text: "课程视频", status: true } }),
      _vm._v(" "),
      _c("div", { staticClass: "videoBox" }, [
        _c("video", {
          attrs: {
            src: _vm.microDetail.new_source_url,
            poster: _vm.microDetail.pic,
            controls: "",
            "webkit-playsinline": "",
            playsinline: "",
            "x5-playsinline": "",
            "x-webkit-airplay": "allow"
          }
        }),
        _vm._v(" "),
        !(_vm.microDetail.payType == 0 || _vm.orderNo)
          ? _c("div", { staticClass: "zhezhao" })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "videoTopBox" }, [
        _c("div", { staticClass: "videoTitle" }, [
          _vm._v(_vm._s(_vm.microDetail.name))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "topCenterBox" }, [
          _c("div", { staticClass: "topLeft" }, [
            _c("div", { staticClass: "videoIcon" }, [_vm._v("视频")]),
            _vm._v(
              "\n        " +
                _vm._s(_vm.microDetail.readCount) +
                "人已参加\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "videoMain" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "mainContent" }, [
          _c("div", { staticClass: "kcjj" }),
          _vm._v(" "),
          _c("div", { staticClass: "mainWord" }, [
            _vm._v(_vm._s(_vm.microDetail.text))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "catalogueBox" }, [
        _c("div", { staticClass: "catalogueBoxTitle" }, [_vm._v("课程目录")]),
        _vm._v(" "),
        _c("div", { staticClass: "catalogueCountBox" }, [
          _vm._v(_vm._s(_vm.courseList.length) + "节系列课")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "catalogueListBox" },
          _vm._l(_vm.courseList, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "catalogueItemBox",
                on: {
                  click: function($event) {
                    _vm.change(item.courseUrl)
                  }
                }
              },
              [
                _vm.microDetail.payType == 0 || _vm.orderNo
                  ? _c("img", {
                      attrs: { src: require("assets/catalogueB.png"), alt: "" }
                    })
                  : _c("img", {
                      attrs: { src: require("assets/catalogueS.png"), alt: "" }
                    }),
                _vm._v(
                  "\n        " +
                    _vm._s(index + 1) +
                    "." +
                    _vm._s(item.courseName) +
                    "\n      "
                )
              ]
            )
          })
        )
      ]),
      _vm._v(" "),
      _vm.microCommentList && _vm.microCommentList.length > 0
        ? _c("div", { staticClass: "commentBox" }, [
            _c("div", { staticClass: "modeTitle" }, [
              _vm._v("\n      全部评论(" + _vm._s(_vm.count) + "):\n      "),
              _c("div")
            ]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.microCommentList, function(item) {
                return _c("li", [
                  _c("div", { staticClass: "userBox" }, [
                    _c("div", { staticClass: "userImg" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "userTopRightBox" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(item.nickName))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm._f("time")(item.createTime)))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "userContent" }, [
                    _vm._v(_vm._s(item.content))
                  ])
                ])
              })
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mask
        ? _c("div", { staticClass: "maskBox" }, [
            _c("div", { staticClass: "inputBox" }, [
              _c("div", { staticClass: "inputTop" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.cancle()
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c("span", { on: { click: _vm.commitMicroComment } }, [
                  _vm._v("提交")
                ])
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.content,
                    expression: "content"
                  }
                ],
                attrs: {
                  autofocus: "",
                  id: "textarea",
                  placeholder: "写下你的看法吧！"
                },
                domProps: { value: _vm.content },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.content = $event.target.value
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.microDetail.payType == 0 || _vm.orderNo
        ? _c("div", { staticClass: "fixedBox" }, [
            _c(
              "div",
              {
                staticClass: "input",
                on: {
                  click: function($event) {
                    _vm.openMask()
                  }
                }
              },
              [
                _c("div", { staticClass: "inputIcon" }),
                _vm._v("\n      写下你的看法吧！\n    ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fabulous",
                class: { actived: _vm.likeStatus },
                on: {
                  click: function($event) {
                    _vm.doLoveMicro()
                  }
                }
              },
              [
                _c("div", { staticClass: "c-num" }, [
                  _vm._v(_vm._s(_vm.microDetail.loveCount))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "toTeacher",
                on: {
                  click: function($event) {
                    _vm.to("ask")
                  }
                }
              },
              [_vm._v("咨询老师")]
            )
          ])
        : _c(
            "div",
            { staticClass: "fixedBox", on: { click: _vm.showPayMask } },
            [
              _c("div", { staticClass: "btn" }, [
                _vm._v("\n      购买系列课"),
                _c("span", [_vm._v("￥")]),
                _vm._v(_vm._s(_vm.microDetail.microPrice) + "\n    ")
              ])
            ]
          ),
      _vm._v(" "),
      _vm.payMask
        ? _c("pay", {
            attrs: {
              price: _vm.microDetail.microPrice,
              microId: _vm.microDetail.microId,
              bookId: ""
            },
            on: { close: _vm.closeMask }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mainTitleBox" }, [
      _c("div", { staticClass: "mainJj active" }, [_vm._v("内容")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf7b2348", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf7b2348","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/courseDetail.vue
// module id = null
// module chunks = 